import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthUsersGuard } from './auth-guard.service';
import {AccreditationCalendarComponent} from '../app/views/accreditation-calendar/accreditation-calendar.component'
import { UnauthorizedComponent } from './views/unautorized-component/unauthorised-page.component';
const routes: Routes = [
  {
    path: 'certificate-regions',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certificate-regions/certificate-regions.module').then(m => m.CertificateRegionsModule)
  },
  {
    path: 'certification-bodies',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certification-bodies/certification-bodies.module').then(m => m.CertificationBodiesModule)
  },
  {
    path: 'certification-marks',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certification-marks/certification-marks.module').then(m => m.CertificationMarksModule)
  },
  {
    path: 'programs',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/programs/programs.module').then(m => m.ProgramsModule)
  },
  {
    path: 'certification-mark-types',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certification-mark-types/certification-mark-types.module').then(m => m.CertificationMarkTypesModule)
  },
  {
    path: 'certification-mark-tags',
    loadChildren: () => import('./views/certification-mark-tags/certification-mark-tags.module').then(m => m.CertificationMarkTagsModule)
  },
  {
    path: 'certification-body-types',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certification-body-types/certification-body-types.module').then(m => m.CertificationBodyTypesModule)
  },
  {
    path: 'accreditors',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/accreditors/accreditors.module').then(m => m.AccreditorsModule)
  },
  {
    path: 'geography-tags',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/geography-tags/geography-tags.module').then(m => m.GeographyTagsModule)
  },
  {
    path: 'site-identifier-tags',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/site-identifier-tags/site-identifier-tags.module').then(m => m.SiteIdentifierTagsModule)
  },
  {
    path: 'business-lines',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/business-lines/business-lines.module').then(m => m.BusinessLinesModule)
  },
  {
    path: 'accreditations',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/accreditations/accreditations.module').then(m => m.AccreditationsModule)
  },
  {
    path: 'revision-types',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/revision-types/revision-types.module').then(m => m.RevisionTypesModule)
  },
  {
    path: 'revision-schemes',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/revision-type-schemes/revision-type-schemes.module').then(m => m.RevisionTypeSchemesModule)
  },
  {
    path: 'certificate-components',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certificate-components/certificate-components.module').then(m => m.CertificateComponentsModule)
  },
  {
    path: 'certificate-component-schemes',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certificate-component-scheme/certificate-component-scheme.module').then(m => m.CertificateComponentSchemeModule)
  },
  {
    path: 'certificate-actions',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/certificate-actions/certificate-actions.module').then(m => m.CertificateActionsModule)
  },
  {
    path: 'event-types',
    canActivate : [AuthUsersGuard],
    loadChildren: () => import('./views/calendar/event-types/event-types.module').then(m => m.EventTypesModule)
  },
  {
    path: 'dashboard',
    canActivate : [AuthUsersGuard],
    loadChildren:()=> import('./views/dashboard/dashboard.module').then(m=>m.DashboardModule)
  },
  {
    path: 'accreditation-calendar',
    canActivate : [AuthUsersGuard],
    component :AccreditationCalendarComponent
  },
  { 
    path: 'authorized',
    component: UnauthorizedComponent
  },
  {
    path: '',
    redirectTo: '/accreditations',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
  providers: [AuthService, AuthUsersGuard]
})
export class RoutingModule { }
